import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPhone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="#123123"
    viewBox="0 0 41 40"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#fff"
      d="M13.058 36.667q-1.152 0-1.922-.77t-.772-1.922V6.025q0-1.15.772-1.92.771-.77 1.922-.772h14.615q1.149 0 1.92.772.77.771.771 1.922v27.948q0 1.15-.77 1.922-.77.77-1.923.77zm7.306-3.27q.517 0 .9-.384a1.23 1.23 0 0 0 .384-.898q0-.515-.384-.9a1.22 1.22 0 0 0-.9-.382 1.25 1.25 0 0 0-.9.384 1.23 1.23 0 0 0-.383.9q0 .52.383.898.384.377.9.382m-8.333-5.832h16.667V9.167H12.03z"
    />
  </svg>
)
export default SvgPhone
